
  import { FreeTrialPreviewModal } from '@/ui/components/modals/FreeTrialPreviewModal';
  import { PageTitle } from '@/ui/components/PageTitle';
  import { pushRoute } from '@/ui/helpers';
  import { useCurrentRoute } from '@/ui/routes';
  import { computed, defineComponent } from 'vue';

  export default defineComponent({
    components: {
      PageTitle,
      FreeTrialPreviewModal,
    },
    setup() {
      const currentRoute = useCurrentRoute();
      const active = computed(() => !!currentRoute.value.query.startingFreeTrial);

      const clearQueries = () => {
        pushRoute({ name: currentRoute.value.name });
      };

      return {
        active,
        clearQueries,
      };
    },
  });
